<template>
  <form class="chi-form chi-reset" @submit.prevent="submit" v-show="!$root.logged_in">
    <div class="container">
      <chi-welcome></chi-welcome>
      <div class="chi-form-section right">
        <chi-announcements></chi-announcements>
        <div class="chi-form-section reset-form">
          <h2 class="with-cropped-hr centered">Forgot your password?</h2>
          <div class="chi-form-group chi-reset-message"
            data-init-message="No prob&shy;lem! En&shy;ter your us&shy;er&shy;name and we&apos;ll send you a link to re&shy;set your pass&shy;word."
            data-done-message="Thank you! You should re&shy;ceive a mes&shy;sage to your reg&shy;is&shy;ter&shy;ed e&shy;mail ac&shy;count with a link to re&shy;set your pass&shy;word (as&shy;sum&shy;ing you en&shy;ter&shy;ed a val&shy;id us&shy;er&shy;name). If you do not get your mes&shy;sage, please check your spam fol&shy;der."
          ></div>
          <div class="chi-reset-errors" id="chi-reset-notifications"
            data-conn-message="Failed to connect to server. Please try again later."
            data-fail-message="Invalid username!"
            data-user-message="Username cannot be blank!"
          ></div>
          <div class="chi-form-group chi-reset-user" :class="{'has-chi-reset-error': error.user}">
            <label class="chi-reset-label" for="user">Username</label><br />
            <input class="k-textbox full-width" id="user" ref="user" tabindex="1" type="text" :name="random" :class="{'k-space-right': error.user}" v-model.lazy="model.username" v-if="user_visible" @keypress="onkeypress" />
            <i class="fal fa-fw fa-exclamation-circle chi-reset-error-icon" :title="error.user ? 'Invalid or blank username' : ''" v-if="error.user"></i>
          </div>
          <div class="chi-button-group chi-form-group">
            <kendo-button class="chi-button-primary" id="reset" sprite-css-class="chi-icon-reset" tabindex="5" type="submit">Get Reset Link</kendo-button>
            <kendo-button class="chi-button-danger" id="cancel" sprite-css-class="chi-icon-cancel" tabindex="6" @click="cancel()">Cancel</kendo-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>


<style lang="scss">
  .chi-form.chi-reset {
    background: linear-gradient(to right, #3c4752 0 calc(50% + 21.14rem), #f8f8f9 calc(50% + 21.14rem) 100%);
    height: 100%;
    padding: 0;
    width: 100%;
    .container {
      height: 100%;
      margin: 0 auto;
      width: 97.14rem;
      &>.chi-form-section {
        float: left;
        height: 100%;
        padding: 2.286rem;
        position: relative;
        &.left {
          width: 69.71rem;
        }
        &.right {
          width: 27.43rem;
        }
        h1 {
          clear: initial;
          color: white;
          float: initial;
          height: 1em;
          font-size: 40px;
          font-weight: initial;
          margin: initial;
          margin-top: 5.714rem;
          padding: initial;
          text-transform: none;
          width: initial;
        }
        h2 {
          font-size: 20px;
          text-transform: uppercase;
        }
        .branding-container {
          .picture-frame {
            height: 14.29rem;
            margin: 2.286rem;
            width: 12.86rem
            img {
              height: 100%;
              width: 100%;
            }
          }
          p {
            color: white;
            line-height: 175%;
            margin-top: 1.143rem;
            a {
              color: inherit;
            }
          }
        }
        .cpt-wrapper {
          bottom: 2.286rem;
          left: 2.286rem;
          margin: 0;
          position: absolute;
          width: 65.14rem;
        }
        .cpt-container {
          color: rgba(128, 128, 128, 0.625);
          font-size: 10pt;
          float: left;
          width: 31.43rem;
          &.right {
            float: right;
          }
          p:first-of-type {
            font-weight: bold;
            text-decoration: underline;
          }
          p:not(:first-of-type) {
            font-style: italic;
          }
        }
        .chi-announcements {
          max-height: 47.5em;
          overflow: auto;
          .chi-announcement {
            color: #676d75;
            float: left;
            margin-top: 1.143rem;
            width: 100%;
            h3 {
              border-bottom: 1px solid rgba(0, 0, 0, 0.08);
              color: #4c8de0;
              font-size: 14px;
              margin: initial;
              padding: 0.2857rem;
              width: 100%;
              .chi-pub-date {
                color: #9c9c9c;
                display: inline-block;
                float: right;
                font-weight: normal;
              }
            }
          }
        }
        .chi-form-section.reset-form {
          bottom: 2.286rem;
          height: auto;
          position: absolute;
          right: 3.429rem;
          width: 20.57rem;
          .chi-form-group {
            color: #676d75;
            margin-right: 0;
            width: 100%;
            label {
              text-align: left;
            }
          }
          .chi-reset-message {
            line-height: normal;
            margin: 1.1429rem auto 0 auto;
          }
          .chi-reset-user {
            margin: 1.1429rem 4.285rem 0 4.285rem;
            position: relative;
            width: 12rem;
            .chi-reset-label {
              width: auto;
            }
          }
          .chi-reset-links {
            height: 40px;
            line-height: normal;
            margin-top: 1.1429rem;
            text-align: center;
            width: 100%;
            .chi-link {
              color: #2f7abf;
            }
          }
          .chi-reset-trusted {
            margin: 1.1429rem auto 0 auto;
            text-align: center;
            .k-checkbox {
              margin-right: 0.28571rem;
              margin-top: 0.92857rem;
              vertical-align: top;
            }
            .k-checkbox-label {
              line-height: normal;
              width: calc(100% - 1.5714rem);
            }
          }
          .chi-button-group {
            margin: 1.1429rem 0 2.1429rem 0;
            width: 100%;
            .k-button {
              float: none;
              #login, #clear {
                float: left;
              }
              #cancel {
                float: right;
              }
            }
          }
          .has-chi-reset-error {
            .chi-reset-label {
              color: #a22;
            }
            .k-textbox {
              border-color: #a22;
            }
            .chi-reset-error-icon  {
              display: block;
            }
          }
          .chi-reset-error-icon {
            bottom: 0.57143rem;
            color: #a22;
            display: none;
            margin: 0.5em 0 0 0;
            overflow: visible;
            position: absolute;
            right: 1.5rem;
            width: 0;
            &:before {
              color: #a22;
            }
          }
          .chi-reset-errors {
            float: left;
            width: 100%;
            &.active {
              margin-top: 1.143rem;
            }
            .k-notification {
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>


<script>
import $ from 'jquery';
import {Button} from '@progress/kendo-buttons-vue-wrapper';
import Announcements from './announcements';
import Welcome from './welcome';

export default {
  name: 'reset',
  components: {
    'chi-announcements': Announcements,
    'chi-welcome': Welcome,
    'kendo-button': Button
  },
  data: function () {
    return {
      error: {user: undefined},
      model: {username: undefined},
      user_visible: true
    }
  },
  errors: undefined,
  notifications: undefined,
  methods: {
    onkeypress: function (event) {
      if (event.which > 31 && event.which < 127)
        try {
          switch (event.target.getAttribute('id')) {
          case 'user':
            this.error.user = undefined;
            break;
          default:
            console.warn('Unexpected field ' + event.target.getAttribute('id'));
            console.debug(event);
          }
        } catch (e) {
          console.error(e);
          console.debug(event);
        }
    },
    clear: function () {
      this.$options.notifications.hide();
      this.error.user = undefined;
      this.model.username = undefined;
      if (this.$refs.user)
        this.$refs.user.focus();
    },
    cancel: function () {
      this.clear();
      this.$root.logout();
    },
    show_error: function (type) {
     this.$options.notifications.error(this.$options.errors.data(type));
    },
    submit: function () {
      var self = this;
      this.$options.notifications.hide();
      if (this.validate()) {
        kendo.ui.progress($('.chi-form-section.reset-form'), true);
        $.ajax({
          contentType: 'application/json; charset=utf-8',
          data: JSON.stringify(this.model),
          type: 'POST',
          url: '/reset?T=' + this.$root.token
        }).done(function () {
          self.clear();
          this.$options.message.html(
            this.$options.message.data('done-message')
          );
          this.$refs.reset.css({display: 'none'});
          this.$refs.cancel
            .removeClass('chi-button-danger')
            .prop('value', 'Return to Login');
          this.$options.cancel.setOptions({spriteCssClass: 'chi-icon-back'});
        }).fail(function () {
          kendo.ui.progress($('.chi-form-section.reset-form'), false);
          self.$root.auth_component = 'reset';
          setTimeout(function () {
            self.clear();
            self.show_error('fail-message');
            self.$refs.user.focus();
          }, 300);
        });
      }
    },
    validate: function () {
      this.error.user = !this.model.username;
      if (this.error.user) {
        this.show_error('user-message');
        this.$refs.user.focus();
      } else {
        return true;
      }
    }
  },
  mounted: function () {
    $('#user').focus();
    var message = this.$options.message = $('.chi-reset-message');
    var errors = this.$options.errors = $('#chi-reset-notifications');
    message.html(message.data('init-message'));
    this.$options.notifications = new kendo.ui.Notification(errors, {
      appendTo: '#chi-reset-notifications',
      autoHideAfter: 10000,
      hide: function () {errors.toggleClass('active', false)},
      show: function () {errors.toggleClass('active', true)}
    });
  },
  //eslint-disable-next-line vue/no-dupe-keys
  props: ['destination', 'message_type', 'has_alternate']
};
</script>
